import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export const UnorderedList = ({
    children,
    className,
    ...props
}: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLUListElement>,
    HTMLUListElement
>) => {
    return (
        <ul
            className={twMerge(
                classNames(
                    'm-0 list-outside list-disc pl-xl font-reg',
                    className
                )
            )}
            {...props}
        >
            {children}
        </ul>
    );
};

export const ListItem = ({
    children,
    className,
    ...props
}: React.DetailedHTMLProps<
    React.LiHTMLAttributes<HTMLLIElement>,
    HTMLLIElement
>) => {
    return (
        <li
            className={twMerge(
                classNames('text-m text-structure-40', className)
            )}
            {...props}
        >
            {children}
        </li>
    );
};
